import {
    type ApiBigqueryDatasets,
    type ApiBigqueryProjectRecommendation,
    type ApiBigqueryProjects,
    type ApiError,
    type ApiSuccessEmpty,
} from '@lightdash/common';
import { useQuery } from '@tanstack/react-query';
import { lightdashApi } from '../api';

const getIsAuthenticated = async () =>
    lightdashApi<ApiSuccessEmpty['results']>({
        url: `/bigquery/sso/is-authenticated`,
        method: 'GET',
        body: undefined,
    });

export const useIsBigQueryAuthenticated = () => {
    return useQuery<ApiSuccessEmpty['results'], ApiError>({
        queryKey: [],
        queryFn: getIsAuthenticated,
    });
};

const getProjects = async () =>
    lightdashApi<ApiBigqueryProjects['results']>({
        url: `/bigquery/sso/projects`,
        method: 'GET',
        body: undefined,
    });

export const useBigqueryProjects = (isAuthenticated: boolean) => {
    return useQuery<ApiBigqueryProjects['results'], ApiError>({
        queryKey: ['bigquery-projects'],
        queryFn: getProjects,
        enabled: isAuthenticated,
    });
};

const getProjectRecommendation = async () =>
    lightdashApi<ApiBigqueryProjectRecommendation['results']>({
        url: `/bigquery/sso/projects/recommendation`,
        method: 'GET',
        body: undefined,
    });

export const useBigqueryProjectRecommendation = (enabled: boolean) => {
    return useQuery<ApiBigqueryProjectRecommendation['results'], ApiError>({
        queryKey: ['bigquery-project-recommendation'],
        queryFn: getProjectRecommendation,
        enabled,
    });
};

const getDatasets = async (projectId: string) =>
    lightdashApi<ApiBigqueryDatasets['results']>({
        url: `/bigquery/sso/datasets?projectId=${projectId}`,
        method: 'GET',
        body: undefined,
    });

export const useBigqueryDatasets = (
    isAuthenticated: boolean,
    projectId: string | undefined,
) => {
    return useQuery<ApiBigqueryDatasets['results'], ApiError>({
        queryKey: [projectId],
        queryFn: () => getDatasets(projectId!),
        enabled:
            isAuthenticated && projectId !== undefined && projectId.length > 0,
    });
};
